var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93659 18.6305C5.83514 18.5578 5.69565 18.5777 5.61051 18.6687C4.47645 19.8833 1.57065 20.7361 1.43841 19.0778C1.43841 17.7795 1.14674 16.6831 0.827899 15.4775C0.436595 14.001 5.29115e-07 12.3591 5.29115e-07 9.97165C-0.00181107 4.28032 4.64855 0 10.163 0C15.6775 0 20 4.48943 20 10.028C20 15.5666 15.5399 19.9451 10.2156 19.9451C8.32609 19.9451 7.40942 19.6778 5.93659 18.6305ZM10.317 4.93491C7.69928 4.79672 5.65761 6.62049 5.20833 9.47162C4.83515 11.8336 5.49638 14.712 6.06159 14.8575C6.30072 14.9193 6.87862 14.4756 7.29891 14.0774C7.37862 14.0029 7.49638 13.9901 7.59058 14.0465C8.24457 14.4484 8.98551 14.7502 9.80435 14.7938C12.4909 14.9357 14.8714 12.8246 15.0127 10.128C15.154 7.43146 13.0054 5.07492 10.3188 4.9331L10.317 4.93491Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxIcon);
export default __webpack_public_path__ + "static/media/max-icon.251b26f73d27f6dce4d5a8625b382496.svg";
export { ForwardRef as ReactComponent };